import * as Yup from 'yup';
import i18next from './i18n';

Yup.setLocale({
  mixed: {
    required: 'validation.required',
  },
  string: {
    email: 'validation.invalid_email',
    max: 'validation.max_length',
  },
  array: {
    min: ({ min }) => i18next.t('validation.min_array_length', { min }),
  },
  number: {
    positive: 'validation.positive_integer',
    min: ({ min }) => i18next.t('validation.min_integer', { min }),
    max: ({ max }) => i18next.t('validation.max_integer', { max }),
  },
});

export default Yup;
